import { Button } from "react-bootstrap";
import { useFiltersContext } from "../contexts/FiltersContext";
import { useTranslation } from 'react-i18next';
import { Locker } from "../data/LockerDataTypes";
import { useSpecificLockerActionContext } from "../contexts/SpecificLockerActionContext";
import { PosFilter } from "./filters/PosFilter";

export const Filters = (): any => {
    const { setShowFilters} = useFiltersContext();
    const { t } = useTranslation();

    const {
        setLockerListSelected
    } = useSpecificLockerActionContext();

    const backToList = (): void => {
        setShowFilters(false);
        setLockerListSelected({} as Locker);
    };

    return (
        <div className="border rounded locker-plugin-locker-filters">
            <div>
                <Button variant="link" size="sm" className="locker-plugin-link-btn locker-plugin-back-to-list-btn" onClick={backToList}>{t("backToLockerList")}</Button>
            </div>
            <ul className="list-group">
                <li>
                    <PosFilter></PosFilter>
                </li>
            </ul>
        </div>
    );

}